import { render } from "./PasswordLogin.vue?vue&type=template&id=63c7a1a8"
import script from "./PasswordLogin.vue?vue&type=script&lang=ts"
export * from "./PasswordLogin.vue?vue&type=script&lang=ts"
script.render = render

export default script